var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_12969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9844 26.1719H6.24999C4.62713 26.1719 4.80869 23.9062 6.01564 23.9062H19.0625C19.337 23.9062 19.6032 24.0855 19.7517 24.2327C20.4403 24.9157 19.8883 26.1719 18.9844 26.1719ZM5.07813 16.4844C5.07813 15.768 5.35558 15.1562 6.24999 15.1562H33.75C35.231 15.1562 35.5123 17.5 33.5156 17.5H6.48439C5.78045 17.5 5.07813 17.1567 5.07813 16.4844ZM5.07813 11.4844C5.07813 10.8447 5.3404 10.1562 6.09374 10.1562H33.9062C35.165 10.1562 35.3942 12.4219 33.8281 12.4219H6.17189C5.54488 12.4219 5.07813 11.944 5.07813 11.4844ZM28.75 7.42189H11.25C9.65176 7.42189 9.74517 5.15625 11.1719 5.15625H28.8281C30.2551 5.15625 30.3411 7.42189 28.75 7.42189ZM0 4.0625V28.5156C0 29.5374 0.649303 30.6261 1.34595 31.3103C1.99602 31.9488 3.10554 32.5 4.375 32.5H22.8125V27.1094C22.8125 23.572 26.2726 20.3125 29.5312 20.3125H30.5469C32.7935 20.3125 34.778 21.7705 35.893 23.2477C36.5592 24.1304 37.2656 25.7515 37.2656 26.9531V32.1094C38.134 32.09 39.2953 30.7204 39.6881 29.8443C39.8117 29.5686 40 28.9131 40 28.5156V4.0625C40 1.99239 38.0076 0 35.9375 0H4.0625C1.99239 0 0 1.99239 0 4.0625Z",
    fill: "#FE8016"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0781 27.5003C25.0781 30.3082 27.3427 32.5003 30.0781 32.5003C34.2963 32.5003 36.7369 27.2447 33.5353 24.0431C30.3524 20.8602 25.0781 23.2329 25.0781 27.5003Z",
    fill: "#FE8016"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 40C26.8888 40 27.7069 39.3151 28.2968 38.9218C28.9069 38.5151 29.4825 38.1332 30.0781 37.7344C30.1868 37.8827 33.2263 40 33.6719 40C35.3667 40 35 38.4665 35 37.0312C35 35.651 35 34.2708 35 32.8906C34.5256 33.1416 34.1948 33.644 32.9916 34.1635C28.4617 36.1196 25.3708 32.9688 25.0781 32.8906L25.0958 39.0448C25.1946 39.5457 25.6048 40 26.25 40Z",
    fill: "#FE8016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_12969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCert);
export default __webpack_public_path__ + "static/media/cert.a78361d81fbcbecc0ee73fcc35ca4db4.svg";
export { ForwardRef as ReactComponent };